/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取剧院logo, 返回logo的链接
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.TheaterLogoDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater-logo`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
